import "./QuoteReviewLayout.scss";

import { useContext, useEffect, useState } from "react";

import QuoteIntentionalLoader from "components/QuoteIntentionalLoader/QuoteIntentionalLoader";
import { IDynamicForm } from "config";
import AboutAD from "containers/AboutAD/AboutAd";
import CaseResultAD from "containers/CaseResultAD/CaseResultAD";
import CaseResultTerm from "containers/CaseResultTerm/CaseResultTerm";
import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { useButtonAction } from "containers/DynamicForm/useButtonAction";
import CoverageEditorRoute from "router/CoverageEditorRoute/CoverageEditorRoute";
import { useAppDispatch } from "store";
import { setJourneyProgressPercentOverride } from "store/actions/journey";
import { getProductOfferings } from "store/actions/product-offerings";
import { getQuote } from "store/actions/quote";
import { isFormExpired } from "utils/form";

interface IProps {
  groups: IDynamicForm["groups"];
  items: IDynamicForm["items"];
  slug: IDynamicForm["slug"];
}

export function QuoteReviewLayout({ groups, items, slug }: IProps) {
  const dispatch = useAppDispatch();
  const { dynamicForm } = useContext(DynamicFormContext);
  const [editingType, setEditingType] = useState<"termLifeOffering" | "adOffering" | "">("");

  const expiredActions = dynamicForm.expiration?.actions || [];
  const expiredActionCommands = useButtonAction(expiredActions);

  const onClickEdit = async (offeringType: "termLifeOffering" | "adOffering") => {
    if (isFormExpired(dynamicForm?.expiration)) {
      await expiredActionCommands();
    } else {
      setEditingType(offeringType);
    }
  };

  const resetEditState = () => {
    setEditingType("");
  };

  useEffect(() => {
    dispatch(setJourneyProgressPercentOverride(undefined));
    dispatch(getQuote());
    dispatch(getProductOfferings());
  }, [dispatch, dynamicForm.expiration?.effectiveUntil]);

  if (editingType) {
    return (
      <CoverageEditorRoute type={editingType} onSave={resetEditState} onBack={resetEditState} />
    );
  }

  if (slug === "about-accidental-death") {
    return <CaseResultAD dynamicFormItems={items} groups={groups} onClickEdit={onClickEdit} />;
  }

  if (slug === "intentional-loader") {
    return <QuoteIntentionalLoader />;
  }

  if (slug === "quote-review-accidental-death") {
    return <AboutAD dynamicFormItems={items} groups={groups} onClickEdit={onClickEdit} />;
  }

  // Term life offering
  return <CaseResultTerm dynamicFormItems={items} groups={groups} onClickEdit={onClickEdit} />;
}
